/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { IActionContext } from '../interfaces';

/**
 * Retrieves performance utils package and cache where the data should be stored.
 * If feature is not enabled or if cache is not present, returns undefined.
 * @param context - Action context.
 * @returns Performance utils package chunk and cache instance.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getPerformanceUtils = (msdyn365Commerce: any, context: IActionContext) => {
    const shouldRunPerformanceAnalysis =
        context.requestContext.features?.enable_performance_analysis && context.requestContext.params.isPerfAnalysis;

    if (!shouldRunPerformanceAnalysis) {
        return undefined;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- Retrieve performance tools binder.
    const performanceUtilsPackage = msdyn365Commerce.perfAnalysisBinder();

    // @ts-ignore -- Property not exposed.
    const cache = context.requestCache?.internalCache;
    if (!cache) {
        return undefined;
    }

    return {
        cache,
        performanceUtilsPackage
    };
};
